<template>
    <el-dialog 
        :visible.sync="dialogVisible" 
        title="导入模板" 
        width="55%" 
        :append-to-body="true"
        :modal-append-to-body="true"
        @close="handleClose">
        
        <!-- 头部切换标签 -->
        <div class="header-tabs">
            <el-tabs v-model="activeTab" @tab-click="handleTabClick">
                <el-tab-pane label="本酒店" name="current"></el-tab-pane>
                <el-tab-pane label="其他酒店" name="other"></el-tab-pane>
            </el-tabs>
        </div>

        <!-- 表格内容 -->
        <div class="table-container">
            <el-table 
                ref="templateTable"
                :data="tableData" 
                style="width: 100%" 
                @current-change="handleCurrentChange"
                @row-click="handleRowClick"
                highlight-current-row
                border
                v-loading="loading">
                
                <el-table-column 
                    align="center"
                    prop="id" 
                    label="模板id" 
                    min-width="200">
                    <template slot-scope="scope">
                        <div class="template-id-cell" :class="{ 'selected': selectedTemplate && selectedTemplate.id === scope.row.id }">
                            <span class="id-text">{{ scope.row.id }}</span>
                            <el-tag 
                                v-if="selectedTemplate && selectedTemplate.id === scope.row.id"
                                type="success" 
                                size="mini" 
                                class="selected-tag">
                                选中
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <!-- v-if="activeTab === 'other'" -->
                
                <el-table-column 
                    align="center"
                    prop="resourceName" 
                    label="酒店名称" 
                    min-width="120">
                </el-table-column>

                <el-table-column 
                    align="center"
                    prop="productName" 
                    label="产品名称" 
                    min-width="120">
                </el-table-column>
                
                <el-table-column 
                    align="center"
                    prop="createTime" 
                    label="创建时间" 
                    min-width="120"
                    :formatter="formatDate">
                </el-table-column>
                
                <!-- <el-table-column 
                    align="center"
                    prop="creator" 
                    label="创建人" 
                    min-width="100">
                </el-table-column> -->
                
                <el-table-column 
                    align="center"
                    label="操作" 
                    width="80">
                    <template slot-scope="scope">
                        <el-button 
                            type="text" 
                            size="small" 
                            @click="previewTemplate(scope.row)">
                            预览
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="requestParameters.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="requestParameters.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>

        <!-- 底部操作按钮 -->
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleConfirm" :disabled="!selectedTemplate">
                确定
            </el-button>
        </div>

        <!-- 预览弹框 -->
        <el-dialog
            :visible.sync="previewVisible"
            title="模板预览"
            width="60%"
            :append-to-body="true">
            <div class="preview-content" v-html="previewContent"></div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="previewVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
import Api from '@/components/Api/index.js'

export default {
    name: 'ImportTemplateDialog',
    data() {
        return {
            dialogVisible: false,
            activeTab: 'current', // current: 本酒店, other: 其他酒店
            tableData: [],
            selectedTemplate: null,
            loading: false,
            total: 0,
            previewVisible: false,
            previewContent: '',
            requestParameters: {
                page: 1,
                size: 10,
                q: {
                    resourceId: '', // 在 openDialog 中初始化,
                    resourceType:0,// -1 代表其他  0代表本酒店
                    
                }
            }

        }
    },
    props: {
        resourceId: {
            type: String,
            default: ''
        }
    },
    methods: {
        // 打开弹框
        openDialog() {
            this.dialogVisible = true
            this.activeTab = 'current'
            this.selectedTemplate = null
            // 初始化请求参数
            this.requestParameters = {
                page: 1,
                size: 10,
                q: {
                    resourceId: this.resourceId,
                    resourceType: 0 // 默认本酒店
                }
            }
            this.loadTemplateData()
        },

        // 关闭弹框
        handleClose() {
            this.dialogVisible = false
            this.selectedTemplate = null
            this.tableData = []
            this.previewVisible = false
        },

        // 切换标签
        handleTabClick(tab) {
            this.activeTab = tab.name
            this.requestParameters.page = 1
            this.loadTemplateData()
        },

        // 选择行
        handleCurrentChange(currentRow) {
            // 只有当用户主动选择时才更新，避免表格数据变化时自动清空
            if (currentRow !== null) {
                this.selectedTemplate = currentRow
            }
        },

        // 点击行选择
        handleRowClick(row) {
            this.selectedTemplate = row
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.requestParameters.size = val
            this.requestParameters.page = 1  // 改变每页大小时重置到第一页
            this.loadTemplateData()
        },

        // 页码改变
        handlePageChange(val) {
            this.requestParameters.page = val
            this.loadTemplateData()
        },

        // 加载模板数据
        async loadTemplateData() {
            this.loading = true
            try {
                // 更新请求参数
                this.updateRequestParameters()

                // 实际API调用
                const response = await new Api('resource').hotelTemplateList(this.requestParameters)
                
                if (response.status === 200) {
                    this.tableData = response.data.records || []
                    this.total = response.data.total || 0
                    
                    // 如果没有数据，给用户提示
                    if (this.tableData.length === 0) {
                        console.log('暂无模板数据')
                    }
                } else {
                    this.$message.error('获取模板数据失败')
                    this.tableData = []
                    this.total = 0
                }

            } catch (error) {
                console.error('加载模板数据失败:', error)
                this.$message.error('加载模板数据失败')
            } finally {
                this.loading = false
            }
        },

        // 更新请求参数
        updateRequestParameters() {
            // 根据当前标签设置 resourceId 和 resourceType
            if (this.activeTab === 'current') {
                // 本酒店
                this.requestParameters.q.resourceId = this.resourceId
                this.requestParameters.q.resourceType = 0
            } else {
                // 其他酒店
                this.requestParameters.q.resourceId = '-1'
                this.requestParameters.q.resourceType = -1
            }
        },

        // 预览模板
        previewTemplate(row) {
            this.previewContent = row.content || '<p>暂无内容</p>'
            this.previewVisible = true
        },

        // 确认选择
        handleConfirm() {
            if (!this.selectedTemplate) {
                this.$message.warning('请选择一个模板')
                return
            }

            // 触发父组件事件，传递选中的模板
            this.$emit('template-selected', this.selectedTemplate)
            this.handleClose()
        },

        // 格式化日期
        formatDate(row, column, cellValue) {
            if (!cellValue) return ''
            const date = new Date(cellValue)
            return date.toLocaleDateString('zh-CN')
        },
    }
}
</script>

<style scoped lang="scss">
.header-tabs {
    margin-bottom: 20px;
    
    ::v-deep .el-tabs__header {
        margin: 0 0 15px 0;
    }
}

.table-container {
    min-height: 300px;
}

.pagination-container {
    margin-top: 20px;
    text-align: right;
}

.dialog-footer {
    text-align: right;
}

.preview-content {
    max-height: 400px;
    overflow-y: auto;
    padding: 20px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fafafa;
    
    ::v-deep p {
        margin: 10px 0;
        line-height: 1.6;
    }
}

::v-deep .el-table__row {
    cursor: pointer;
}

::v-deep .el-table__row.current-row {
    background-color: #ecf5ff;
}

.template-id-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 6px;
    transition: all 0.3s ease;
    
    .id-text {
        font-weight: 500;
        transition: all 0.3s ease;
    }
    
    .selected-tag {
        margin-left: 8px;
        animation: fadeIn 0.3s ease-in-out;
    }
    
    // 选中状态样式
    &.selected {
        background: linear-gradient(135deg, #67c23a, #85ce61);
        color: white;
        box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
        transform: scale(1.02);
        
        .id-text {
            color: white;
            font-weight: 600;
        }
        
        .selected-tag {
            background: rgba(255, 255, 255, 0.2);
            border-color: rgba(255, 255, 255, 0.3);
            color: white;
        }
    }
    
    // 悬停效果
    &:not(.selected):hover {
        background-color: #f5f7fa;
        transform: translateY(-1px);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
